import React from "react";
import { ArrowUpRight } from "lucide-react";
import { ASSETS, STREAM_LINKS } from "@/data/content";
import { Reveal } from "./Reveal";

const Footer = () => {
  return (
    <footer className="pb-40 pt-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <Reveal>
          <div className="afr-grain relative overflow-hidden rounded-3xl bg-black p-10 sm:p-16 text-white">
            <div className="relative z-10 max-w-2xl">
              <p className="text-sm font-medium tracking-widest text-neutral-400 mb-4">
                A FLAT RECORDS
              </p>
              <h2 className="font-heading text-4xl sm:text-6xl font-semibold tracking-tight leading-[0.95]">
                Engineered to resonate globally.
              </h2>
              <div className="mt-10 flex flex-wrap gap-3">
                <a
                  href={STREAM_LINKS.spotify}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-spotify"
                  className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3.5 font-medium text-black transition-colors duration-300 hover:bg-neutral-200"
                >
                  Spotify <ArrowUpRight size={16} />
                </a>
                <a
                  href={STREAM_LINKS.apple}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-apple"
                  className="inline-flex items-center gap-2 rounded-full border border-white/25 px-6 py-3.5 font-medium text-white transition-colors duration-300 hover:bg-white/10"
                >
                  Apple Music <ArrowUpRight size={16} />
                </a>
              </div>
            </div>
            <div className="absolute -bottom-16 -right-8 font-heading text-[28vw] sm:text-[16rem] font-bold leading-none text-white/5 select-none pointer-events-none">
              AFR
            </div>
          </div>
        </Reveal>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-6 border-t border-gray-200 pt-8">
          <div className="flex items-center gap-2.5">
            <img src={ASSETS.logo} alt="A Flat Records" className="h-6 w-auto" />
            <span className="font-heading text-sm font-semibold tracking-tight">
              A FLAT RECORDS
            </span>
          </div>
          <p className="text-sm text-neutral-400">
            © {new Date().getFullYear()} A Flat Records. Precision in sound.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
